import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import {EDPageLoader, EEDAnimation, error} from "@trailblazer-game/ed-webkit";
import Home_Header from "../Components/Home_Header";
import Home_Banner from "../Components/Home_Banner";
import Home_Separator from "../Components/Home_Separator";
import Home_Carousel from "../Components/Home_Carousel";
import Home_PlayNow from "../Components/Home_PlayNow";
import {useEffect, useState} from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { theme } from "../../../Theme/Theme";
import {ELeagueActions} from "../../League/Public/League_State";
import {log, warn} from "../../../../helpers/utils/log";
import {ClientLeagueAPI} from "@trailblazer-game/leaderboards-sdk";
const clientLeagueAPI = new ClientLeagueAPI();

interface IHomeProps {
  className?: string;
}

const Home = ({ className }: IHomeProps) => {
  const isMedium = useMediaQuery(theme.breakpoints.down("md"));
  const [seasonName, setSeasonName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const nextWrapper = document.getElementById("__next");
    nextWrapper?.classList.add("homepage");

    loadLeaderboardConfig();

    return () => {
      nextWrapper?.classList.remove("homepage");
    }
  }, []);

  const loadLeaderboardConfig = async () => {

    let res = await clientLeagueAPI.getConfig();

    if (res.success) {
      setSeasonName(res.config.seasonName);
    } else {
      warn('Home', "Something went wrong while getting leaderboard configuration:", res);
    }

    setLoading(false);
  }


  return <Stack className={`${className} ${EEDAnimation.FadeIn}`} spacing={isMedium ? 8 : 16} alignItems={"center"}
                justifyContent={"center"}>
    <Home_Header seasonName={seasonName}/>

    <Home_Banner
      leftImage={"/home/banner-image-01.webp"}
      rightImage={"/home/banner-image-02.webp"}
      title={"The Fate of the Realm is at your Fingertips"}
      align={"center"}
      content={[
        "You will need all your wit and cunning to master the Skills of a Dragoneer.",
        "Battle warlords, titans, and friends alike.",
        "Capture and tame your very own Dragons.",
        "That will be yours to keep!"
      ]}
    />

    <Stack spacing={4} alignItems={"center"} justifyContent={"center"} sx={{ width: "100%" }}>
      <Home_Separator title={"Master Unique Dragon Classes"}/>

      <Home_Carousel
        images={[ "/home/dragon-1.webp", "/home/dragon-2.webp", "/home/dragon-3.webp", "/home/dragon-4.webp", "/home/dragon-5.webp" ]}/>
    </Stack>

    <Stack spacing={4} alignItems={"center"} justifyContent={"center"} sx={{ width: "100%" }}>
      <Home_Separator title={"And powerful minions"}/>

      <Home_Carousel
        images={[ "/home/minion-1.webp", "/home/minion-2.webp", "/home/minion-3.webp", "/home/minion-4.webp", "/home/minion-5.webp" ]}
        imageAspectRatio={"0.94"}/>
    </Stack>

    <Home_Banner
      leftImage={"/home/banner-image-03.webp"}
      rightImage={"/home/banner-image-04.webp"}
      content={[
        "Use Affinity Combos and chain your attacks for devastating power!",
        "Bring your opponents to their knees, or be crushed in the attempt!",
        "",
        "Each unit you find will have unique properties, allowing you to craft complex strategy, outsmarting the fiercest of foes."
      ]}
    />

    <Home_Banner
      leftImage={"/home/banner-image-05.webp"}
      rightImage={"/home/banner-image-06.webp"}
      content={[
        "Level up your units during battle, and use your Dragons to dominate the arena.",
        ""
      ]}
    />

    <Home_PlayNow/>

    {loading ? <EDPageLoader in={true}/> : null}
  </Stack>
}

const HomeStyled = styled(Home)(() => ({
  overflow: "hidden",
  width: "100%",
}));

// Export
export default HomeStyled;